module.exports = __webpack_public_path__ + "img/338.28f04b73.png";